import {get, patch} from "./http";
import {API_URL_HTTP} from "../config/api";
import {account$, loadingSignOut$, onAccount} from "../emitters/account";
import {USER_TYPE_PARTNER} from "../constants";

const delay = require('mn-utils/delay');
const toLower = require('mn-utils/toLower');
const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const {
  post,
} = require('./http');
const {
  USER_TYPE_ADMIN,
  USER_TYPE_MERCHANT,
  USER_TYPE_OPERATOR,
  DEFAULT_CURRENCY,
  DEFAULT_AVATAR_CORP,
} = require('../constants');
const {
  LINK_SIGN_IN,
} = require('../constants/links');
const {
  replaceLocation,
} = require('../router');
const isErrorNoConnect = require('../utils/isErrorNoConnect');
const {
  localStore,
} = require('../stores');
const MOCK_TYPES = {
  'admin@lunu.io': USER_TYPE_ADMIN,
};

export function apiAuthGetMerchantAccounts(params) {
  return get('/f2c/v1/console/accounts/group', params, () => {
    userSignUp$.emit(params);
    return {};
  });
}
export function apiAuthGetAccountConfig(params) {
  return get('/f2c/v1/console/config', params, () => {
    userSignUp$.emit(params);
    return {};
  });
}

function handleUser(user) {
  if (!user || (typeof user === 'object' && !Object.keys(user).length)) {
    return 0;
  }

  const accountType = user.account_type || user.role;

  const userData = {
    ...user,
    enabled: true,
    admin: accountType === USER_TYPE_ADMIN,
    merchant: accountType === USER_TYPE_MERCHANT,
  }

  if (user.tfa_enabled && !user.tfa_passed) return userData;

  return new Promise((resolve) => {
    const getConfig = [USER_TYPE_MERCHANT, USER_TYPE_PARTNER].includes(accountType)
      ? apiAuthGetAccountConfig
      : () => new Promise((res) => res({}));

    getConfig().then((res) => {
      Object.keys(res).forEach((key) => userData[key] = res[key]);

      apiAuthGetMerchantAccounts()
        .then((res) => {
          const list = res.count
            ? res.list
            : [user];

          const accountsData = {};
          const accountsList = list.map(({id, login, ...account}) => {
            const accountType = account.account_type || account.role;

            accountsData[id] = {
              id,
              login,
              enabled: true,
              admin: accountType === USER_TYPE_ADMIN,
              merchant: accountType === USER_TYPE_MERCHANT,
              ...account
            };

            return {id, login, disabled: id === user.id}
          }).sort((prev) => !!prev.disabled ? -1 : 1);

          return {accountsData, accountsList};
        })
        .then(({accountsData, accountsList}) => {
          resolve({
            ...userData,
            accountsData,
            accountsList
          })
        });
    })
  });
}

export const user$ = localStore('mockUser', 0);
const {
  emit: emitUser,
  getValue: getUser,
} = user$;
export const userSignUp$ = localStore('mockSignUp', 0);


export function apiAuthSignUpMerchant(params) {
  return post('/v2/auth/sign-up/merchant', params, () => {
    userSignUp$.emit(params);
    return {};
  });
}

export function apiReloginMerchant(params) {
  loadingSignOut$.emit(true);

  setTimeout(() => {
    return get(`/f2c/v1/console/accounts/${params.id}/switch`, params, () => {})
        .then(() => {
          const account = account$.getValue();
          const accountsData = (account || {}).accountsData || {};
          const nextUserData = accountsData[params.id];

          const accountType = nextUserData.account_type || nextUserData.role;
          const getConfig = [USER_TYPE_MERCHANT, USER_TYPE_PARTNER].includes(accountType)
            ? apiAuthGetAccountConfig
            : () => new Promise((res) => res({}));

          return getConfig().then((res) => {
            Object.keys(res).forEach((key) => nextUserData[key] = res[key]);

            const accountsList = (account.accountsList || [])
                .map((el) => ({...el, disabled: el.id === params.id}))
                .sort((prev) => !!prev.disabled ? -1 : 1);

            onAccount({...nextUserData, accountsData, accountsList});
          });
        })
        .finally(() => loadingSignOut$.emit(false));
  }, 1000);
}
export function apiAuthSignIn(params) {
  return post('/f2c/v1/console/sign-in', params, () => {
    // mock
    const {
      email,
    } = params;
    const accountType = MOCK_TYPES[email] || USER_TYPE_MERCHANT;
    const response = {
      // blocked: true,
      // need_tfa: true,
      enabled: true,
      has_avatar: true,
      version: 'local mock',
      username: email,
      fullname: 'Liza',
      fiat_code: DEFAULT_CURRENCY,
      company: 'Thyssen-Bornemisza Art Contemporary Academy',
      console_role: accountType,
    };
    user$.emit(response);
    return response;
  }).then(handleUser, (error) => {
    if (error.code === 149) {
      return {blocked: 1};
    } else if (error.code === 401) {
      return null;
    }
    throw error;
  });
}
export function apiAuthSignOut() {
  return post('/f2c/v1/console/sign-out', null, () => {
    emitUser(0);
    return {};
  });
}

export function apiAuthUser(props) {
  const params = {
    ...props,
    handleError: (err) => {
      if (err.code === 401) {
        return null;
      }
    }
  };

  return post('/f2c/v1/console/auth/user', params, getUser).then(handleUser);
}

export function apiAuthUpdatePwd(params) {
  return patch('/f2c/v1/console/accounts', params).then(handleUser);
}

export function apiAuthRecoveryToken(params) {
  return post('/f2c/v1/console/auth/password/recovery-token', params);
}

export function apiAuthPasswordRecovery(params) {
  return post('/f2c/v1/console/auth/password/reset', params);
}

export function apiAuthEmailConfirm(params) {
  return post('/v1/auth/email/confirm', params, () => {
    // mock
    const user = userSignUp$.getValue();
    emitUser({
      username: user.email,
    });
    return {
      token: user.action,
    };
  });
}
export function apiAuthResendConfirmationV2(params) {
  return post('/v2/auth/email/resend_confirmation', params, () => {
    // mock
    userSignUp$.emit(params);
    return {};
  });
}
export function apiAuthTfaBind(params) {
  return post('/f2c/v1/console/auth/tfa/bind', params, () => {
    // mock
    return {
      secret: 'I53SISZC2UJQZCYIMBI2PIAF5ZMT47JA',
      qrcode_url: 'https://img-android.lisisoft.com/imgmic/2/4/3942-i-com.notes.education.test.educationalapp.jpg',
    };
  });
}
export function apiAuthTfaQR() {
  return fetch(API_URL_HTTP + '/f2c/v1/console/auth/tfa/qrcode', {method: 'GET', credentials: 'include'});
}
export function apiAuthTfaConfirm(params) {
  return post('/f2c/v1/console/auth/tfa/confirm', params);
}

export function apiAuthTfaVerify(params) {
  params = params || {};
  const handleError = params.handleError;
  return post('/f2c/v1/console/auth/tfa/verify', {
    ...params,
    handleError(error) {
      const {
        code,
      } = error;
      if (code === 149 || code === 108) {
        return {
          blocked: 1,
        };
      }
      if (handleError) {
        return handleError(error);
      }
      throw error;
    },
  }, () => {
    // mock
    emitUser({
      ...getUser(),
      need_tfa: 0,
    });
    return {};
  }).then(handleUser);
}

export function apiAuthTfaDisable(params) {
  return post('/f2c/v1/console/auth/tfa/disable', params, () => {
    // mock
    return {status: 'SUCCESS'};
  });
}

export function apiAuthCheckEmail(params) {
  return post('/v1/auth/check-email', params, () => {
    return {
      invalid: params.email === 'mr.amirka@ya.ru',
    };
  }).then((v) => {
    // mock
    return {
      invalid: toLower(v && v.status || '') == 'invalid',
    };
  });
}

export const auth$ = new Emitter();
export const loadingSession$ = new Emitter();
export const loadingReconnect$ = new Emitter();
let promiseCheckSession = new CancelablePromise();
export const handleReconnectMerchant = handleReconnectProvider(USER_TYPE_MERCHANT);
export const handleReconnectAdmin = handleReconnectProvider(USER_TYPE_ADMIN);

export function handleReconnectProvider(accountType) {
  return (error) => {
    loadingReconnect$.emit(1);
    return checkSessionWithoutLoading().then((user) => {
      if (user) {
        if (user.account_type === accountType) {
          return user;
        }
        refreshSession();
        throw new Error('Incorrect account type');
      }
      refreshSession();
      throw new Error('Session expired');
    }).finally(loadingReconnect$.bind(0));
  };
}
export function reconnectTimeout() {
  return CancelablePromise.delay(10000);
}
export function decorateReconnect(request, _checkSession) {
  const reconnect = _checkSession
    ? (() => _checkSession().catch((error) => {
      if (isErrorNoConnect(error)) {
        return reconnectTimeout().then(reconnect);
      }
      throw error;
    }))
    : reconnectTimeout;

  return (params) => {
    function base() {
      return request(params).catch((error) => {
        // console.log('decorateReconnect', err.message);
        if (isErrorNoConnect(error)) {
          return reconnect().then(base);
        }
        throw error;
      });
    }
    return base();
  };
}
export function checkSessionWithoutLoading() {
  if (loadingSession$.getValue()) {
    return promiseCheckSession;
  }
  loadingSession$.emit(1);
  return promiseCheckSession = decorateReconnect(apiAuthUser)()
      .finally(loadingSession$.bind(0));
}
function checkSession() {
  loadingReconnect$.emit(1);
  return checkSessionWithoutLoading()
      .then((v) => {
        if (v) {
          return v;
        }
        refreshSession();
        throw new Error('Session expired');
      })
      .finally(loadingReconnect$.bind(0));
}
export function decorateReconnectIfSession(request) {
  return (params) => {
    function base() {
      return request(params).catch((error) => {
        // console.log('decorateReconnect', err.message);
        if (isErrorNoConnect(error)) {
          return checkSession().then(base);
        }
        throw error;
      });
    }
    return base();
  };
}
export function refreshSession() {
  auth$.emit(0);
  replaceLocation({
    path: LINK_SIGN_IN,
  });
  delay(() => {
    window.location.reload();
  }, 100);
}
